/*
 * Footer Messages
 *
 * This contains all the text for the Footer component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  loginTitle: {
    id: 'login.title.message',
    defaultMessage: 'Welkom op de analyse APP.'
  },
  loginMessage: {
    id: 'login.message.message',
    defaultMessage: 'Log in met jouw e-mail en wachtwoord.'
  },
  signupFirstName: {
    id: 'login.username.firstname',
    defaultMessage: 'Voornaam'
  },
  signupLastName: {
    id: 'login.username.latname',
    defaultMessage: 'Naam'
  },
  loginUsername: {
    id: 'login.username.email',
    defaultMessage: 'E-mail'
  },
  loginPassword: {
    id: 'login.password.message',
    defaultMessage: 'Wachtwoord'
  },
  loginPasswordRepeat: {
    id: 'login.password.repeat.message',
    defaultMessage: 'Wachtwoord bevestigen'
  },
  loginExperience: {
    id: 'login.experience.message',
    defaultMessage: 'Aantal jaren les ervaring'
  },
  loginSubmitButton: {
    id: 'login.submit.button',
    defaultMessage: 'Aanmelden'
  },
  setPasswordSubmitButton: {
    id: 'setpassword.submit.button',
    defaultMessage: 'Aanmaken'
  },
  setPasswordMessage: {
    id: 'setpassword.message',
    defaultMessage:
      'Maak een nieuw wachtwoord aan om in te loggen op uw account'
  },
  loginPasswordForgotten: {
    id: 'login.password.forgotten',
    defaultMessage: 'Wachtwoord vergeten?'
  },
  loginSignup: {
    id: 'login.signup',
    defaultMessage: 'Nieuwe gebruiker'
  },
  signupTitle: {
    id: 'signup.title.message',
    defaultMessage: 'Welkom op de analyse APP.'
  },
  signupMessage: {
    id: 'signup.message.message',
    defaultMessage:
      'Gelieve een e-mail en wachtwoord te geven waarmee je zou willen inloggen op de app'
  },
  signupUsername: {
    id: 'signup.username.message',
    defaultMessage: 'E-mail'
  },
  signupPassword: {
    id: 'signup.signup.message',
    defaultMessage: 'Wachtwoord'
  },
  signupSubmitButton: {
    id: 'signup.submit.button.message',
    defaultMessage: 'Registreer'
  },
  forgotTitle: {
    id: 'forgot.title.message',
    defaultMessage: 'Wachtwoord vergeten'
  },
  forgotEmail: {
    id: 'forgot.email.message',
    defaultMessage: 'E-mail'
  },
  forgotMessage: {
    id: 'forgot.message.message',
    defaultMessage: 'Geef uw e-mailadres en we sturen u een mail'
  },
  forgotSubmitButton: {
    id: 'forgot.password.message',
    defaultMessage: 'Wachtwoord vergeten'
  },
  forgotSuccessMessage: {
    id: 'forgot.success.message',
    defaultMessage:
      'Check uw e-mail, u heeft normaal een email ontvangen met ...'
  },
  signupSuccessMessage: {
    id: 'signup.success.message',
    defaultMessage:
      'Registratie is gelukt. Check uw e-mail, u heeft een email ontvangen met een link om uw wachtwoord aan te maken.'
  },
  errorPasswordNotEqual: {
    id: 'error.password.not.equal',
    defaultMessage: 'Het wachtwoord is niet gelijk'
  },
  errorPasswordEmpty: {
    id: 'error.password.empty',
    defaultMessage: 'Wachtwoord ontbreekt'
  },
  errorPasswordTooShort: {
    id: 'error.password.too.short',
    defaultMessage: 'Het wachtwoord is te kort'
  },
  errorPasswordNoAlphabeticalChar: {
    id: 'error.password.no.alphabetical.char',
    defaultMessage: 'Het wachtwoord moet minstens 1 letter bevatten'
  },
  errorPasswordNoNumericalChar: {
    id: 'error.password.no.numerical.char',
    defaultMessage: 'Het wachtwoord moet minstens 1 cijfer bevatten'
  },
  errorSomethingWentWrong: {
    id: 'error.something.went.wrong',
    defaultMessage: 'Something went wrong!'
  }
});
